import { Oauth1ProviderData, OidcProviderData } from "@istari/istari-client";

import { Oauth1ProviderConfig } from "../../model/oauth1-provider-config";
import { OidcProviderConfig } from "../../model/oidc-provider-config";

// The read-side shapes: every optional write-side field resolves to a concrete value (absent →
// ""/false). The OAuth 1.0a dialect fields are the exception: unset means "use the catalog
// default" on the backend, so they keep their absent state through a read-edit-save round trip
// instead of being flattened into a literal that would freeze the default.
export type OidcConfig = Required<OidcProviderConfig>;
export type Oauth1Config = Required<
  Omit<Oauth1ProviderConfig, "extraTokenHeaders" | "twoLeggedEmptyToken" | "authChallengeHeaders">
> &
  Pick<Oauth1ProviderConfig, "extraTokenHeaders" | "twoLeggedEmptyToken" | "authChallengeHeaders">;

export function toOidcConfig(data: OidcProviderData): OidcConfig {
  return {
    issuer: data.issuer,
    clientId: data.clientId,
    authorizationEndpoint: data.authorizationEndpoint ?? "",
    tokenEndpoint: data.tokenEndpoint ?? "",
    scopes: data.scopes ?? [],
    usePkce: data.usePkce ?? false,
    clientSecretHeader: data.clientSecretHeader ?? "",
    sendScopeOnRefresh: data.sendScopeOnRefresh ?? false,
    sendRedirectUriOnRefresh: data.sendRedirectUriOnRefresh ?? false,
    tlsCaPem: data.tlsCaPem ?? "",
    tlsVerify: data.tlsVerify ?? true,
  };
}

export function toOauth1Config(data: Oauth1ProviderData): Oauth1Config {
  return {
    baseUrl: data.baseUrl,
    consumerKey: data.consumerKey,
    requestTokenEndpoint: data.requestTokenEndpoint ?? "",
    authorizationEndpoint: data.authorizationEndpoint ?? "",
    accessTokenEndpoint: data.accessTokenEndpoint ?? "",
    rootservicesPath: data.rootservicesPath ?? "",
    identityPath: data.identityPath ?? "",
    extraTokenHeaders: data.extraTokenHeaders ?? undefined,
    twoLeggedEmptyToken: data.twoLeggedEmptyToken ?? undefined,
    authChallengeHeaders: data.authChallengeHeaders ?? undefined,
    tlsCaPem: data.tlsCaPem ?? "",
    tlsVerify: data.tlsVerify ?? true,
  };
}
